import React from 'react';
import { Box, Button, Typography } from '@mui/material';

interface CorruptedVendorsActionsProps {
  companyName: string;
  onDownloadCorruptedVendors: (companyName: string) => void;
}

const CorruptedVendorsActions: React.FC<CorruptedVendorsActionsProps> = ({ companyName, onDownloadCorruptedVendors }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Typography variant="body2" color="error">
        Corrupted vendors found!
      </Typography>
      <Button
        variant="outlined"
        color="error"
        size="small"
        onClick={() => onDownloadCorruptedVendors(companyName)}>
        Download List
      </Button>
    </Box>
  );
};

export default CorruptedVendorsActions;
